import { jkLib } from './jkCommon';
import { enableProdMode } from '@angular/core';
import { JkEnvironment } from './jkInterface';
//import { NativeDateAdapter } from '@angular/material/core';

/*
export class CustomDateAdapter extends NativeDateAdapter {
  override format(date: Date, displayFormat: Object): string {
    let day = date.getDate();
    let month = date.getMonth() + 1;
    let year = date.getFullYear();

    return `${year}/${this.pad(month)}/${this.pad(day)}`;
  }

  private pad(n: number): string {
    return ('00' + n).slice(-2);
  }
}
*/

export class openwinItemClass {
  name: string = '';
  list: object[] = [];
}

// 用不到了?  指放置全域變數的地方
export class jkAppClass {
  openwinList: openwinItemClass[] = [];
  env!: JkEnvironment;
  constructor() {
    console.log('jkAppClass');
  }
  init(env: JkEnvironment) {
    this.env = env;
  }
  save() {
    jkLib.saveLocalStorageItem(this.env.appName, this.openwinList);
  }
  load() {
    let obj = {};
    if (jkLib.loadLocalStorageItem(this.env.appName, obj)) {
      jkLib.cloneField(obj, this.openwinList);
    }
  }
  getList(name: string): object[] {
    let result: object[] = [];
    let item = this.openwinList.find((x) => x.name == name);
    if (item) {
      result = item.list;
    }
    return result;
  }
  setList(name: string, list: object[]) {
    let item = this.openwinList.find((x) => x.name == name);
    if (item) {
      item.list = list;
    } else {
      item = new openwinItemClass();
      item.name = name;
      item.list = list;
      this.openwinList.push(item);
    }
  }
}

export function jkMain(defaultLogin: boolean): boolean {
  let result = false;

  if (!/localhost/.test(document.location.host)) {
    enableProdMode();
    console.log('enableProdMode');
  }

  return result;
}
